<template>
  <DxLookup
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :data-source="dataSource"
    :value.sync="currentValue"
    display-expr="SupplierName"
    value-expr="SupplierName"
    :search-expr="['SupplierName']"
    search-mode="contains"
    :on-item-click="onItemClicked"
    item-template="itemSupplier"
    field-template="itemSupplier"
    @focus-in="focusIn"
    :disabled="disabled"
    :placeholder="''"
    :on-value-changed="onSupplierChanged"
  >
    <template #itemSupplier="{ data }">
      <div class="custom-auto-complete">
        <span class="auto-complete-primary">{{ data.SupplierName }}</span>
        <span class="auto-complete-secondary">{{ data.SupplierCode }}</span>
      </div>
    </template>
  </DxLookup>
</template>
<script>
import { DxLookup } from "devextreme-vue/lookup";
const dropDownBoxRefName = "dropDownBoxRef";

export default {
  components: {
    DxLookup,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onItemClick: {
      type: Function,
      default: () => function() {},
    },
    dataSource: {
      type: Array,
      default: () => {},
    },
    cellInfo: {
      type: Object,
      default: () => {},
    },
    focusIn: {
      type: Function,
      default: () => function() {},
    },
    onValueChanged: {
      type: Function,
      default: () => function() {},
    },
  },
  data() {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onSupplierChanged(valueChangedArgs) {
      this.onValueChanged(valueChangedArgs, this.cellInfo);
    },
    onItemClicked(selectionChangedArgs) {
      this.currentValue = selectionChangedArgs.itemData.SupplierName;
      this.onItemClick(selectionChangedArgs, this.cellInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-dropdown-list-item {
  font-size: 14px;
}
</style>
